import { useRef } from "react";
import useReveal from "@/hooks/useReveal";

const photos = [
  {
    src: "/images/site/bei-der-arbeit.webp",
    alt: "Frisch angerichtet in der Küche von Niko's Grill",
    caption: "Frisch vom Grill",
  },
  {
    src: "/images/site/innenbereich-2.webp",
    alt: "Gemütlicher Gastraum bei Niko's Grill",
    caption: "Unser Gastraum",
  },
  {
    src: "/images/site/zapfen.webp",
    alt: "Frisch gezapftes Veltins bei Niko's Grill",
    caption: "Frisch gezapft",
  },
];

export default function Gallery() {
  const ref = useRef(null);
  useReveal(ref);

  return (
    <section
      ref={ref}
      data-testid="gallery-section"
      className="relative bg-[var(--niko-cream)] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-14 md:mb-16">
          <p className="reveal divider-leaf max-w-[180px] mx-auto mb-8">Einblicke</p>
          <h2
            className="reveal reveal-delay-1 font-display text-4xl sm:text-5xl lg:text-6xl text-[var(--niko-charcoal)] leading-[1.05]"
            data-testid="gallery-headline"
          >
            Mitten im <span className="italic text-[var(--niko-blue)]">Geschehen</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 md:gap-7">
          {photos.map((p, i) => (
            <figure
              key={p.src}
              data-testid={`gallery-photo-${i}`}
              className={`reveal reveal-delay-${i + 1} group relative overflow-hidden rounded-sm`}
            >
              <img
                src={p.src}
                alt={p.alt}
                loading="lazy"
                className="w-full aspect-[4/5] sm:aspect-[3/4] object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <figcaption className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-[var(--niko-dark)]/80 to-transparent px-5 pt-14 pb-4">
                <span className="font-greek italic text-lg text-white">
                  {p.caption}
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
